export const generateFriendlyErrorString = (friendlyMessage, errorBody) => {
    if (!errorBody.breadcrumb) {
        return friendlyMessage;
    }

    return `${friendlyMessage} If this continues, please contact us with this code: ${errorBody.breadcrumb}`;
};
